// Tiny app-wide toast bus. Imperative API so any component can fire a
// toast without threading context/props: `import { toast } from
// '../lib/toast.js'; toast.success('Saved', 'details…')`. A single
// <ToastHost/> (mounted at the app root) subscribes and renders them
// via a portal above modals (--z-toast).

let listeners = [];
let seq = 0;

export function subscribe(fn) {
  listeners.push(fn);
  return () => { listeners = listeners.filter((l) => l !== fn); };
}

function emit(t) {
  for (const l of listeners) l(t);
}

// duration ms; 0 = sticky (manual dismiss only).
export function showToast({ title, body, tone = 'info', duration = 6000 }) {
  emit({ id: ++seq, title, body, tone, duration });
}

export const toast = {
  success: (title, body, opts = {}) => showToast({ title, body, tone: 'success', duration: 6000, ...opts }),
  error:   (title, body, opts = {}) => showToast({ title, body, tone: 'error',   duration: 10000, ...opts }),
  info:    (title, body, opts = {}) => showToast({ title, body, tone: 'info',    duration: 6000, ...opts })
};
